import type { LoadDashboard } from '@/domain/use-cases/dashboard.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';

export class DashboardController extends BaseControllerImpl {
    constructor(private readonly loadDashboardUseCase: LoadDashboard) {
        super();
    }

    public async loadDashboard(params?: LoadDashboard.Params) {
        return this.loadDashboardUseCase.execute(params);
    }
}
